import { useI18n } from '@cascade/react/i18n';
import type { TErrorFallbackProps } from '@cascade/react/error-boundary';
import { Button, Text } from '@cascade/ui-library';
import styles from './ErrorPage.module.scss';

export const ErrorPage = ({ error, reset }: TErrorFallbackProps) => {
  const { translate, translateError } = useI18n();

  return (
    <div className={styles['error-page']}>
      <Text type='h4' content={translate('errorPage.title')} />
      <Text type='body-2' role='alert' content={translateError(error)} />
      <Button label={translate('errorPage.retry')} onClick={reset} />
    </div>
  );
};
